var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PASSWORD-FORGOT"},[_c('forgot-password-form',{attrs:{"default-email":_vm.email}}),_vm._v("\n  Already have an account?\n  "),_c('router-link',{staticClass:"link",attrs:{"to":{
        name: 'login',
        query: {
          email: _vm.email,
          redirectTo: this.redirectTo
        },
        params: {
          proLogin: this.proLogin
        }
      },"selenium":"login-forgot-password-link"}},[_vm._v("\n    Sign in with password.\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }